<template>
  <div class="page">
    <section class="section primary-header">
      <div class="container is-fluid">
        <h1 class="title is-2">Contacts</h1>
        <h2 class="subtitle">View, filter, search, and segment your leads and users</h2>
      </div>
    </section>

    <section class="section content-container">
      <n-loading-spinner v-if="isLoading"></n-loading-spinner>
      <div class="container is-fluid" v-show="!isLoading">
        <div class="island">
          <router-view @loaded="isLoading = false" @loading="isLoading = true"></router-view>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const isLoading = ref(true);
</script>
